import {
    Component,
    ElementRef,
    OnDestroy,
    OnInit,
    TemplateRef,
    ViewChild,
} from '@angular/core';
import { CartButtonService } from '@app/components/cart-button/cart-button.service';
import { ScrollDirectionService } from '@app/services/scroll-direction.service';
import { UserService } from '@app/services/user.service';
import { SidebarService } from '@app/sidebar/sidebar.service';
import { EventService, EventType } from '@app/utilities/event.service';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import * as Sentry from '@sentry/angular-ivy';
import { Subscription } from 'rxjs';

@Component({
    selector: 'md-appbar',
    templateUrl: './appbar.component.html',
    styleUrls: ['./appbar.component.scss'],
})
export class AppbarComponent implements OnInit, OnDestroy {
    isUserLoggedIn = true;

    @ViewChild('signOutModal') signOutModal: TemplateRef<unknown>;
    @ViewChild('container') container: ElementRef;

    private userServiceSubscription: Subscription;
    previousScrollDirection: 'up' | 'down' = 'up';

    constructor(
        public cartButtonService: CartButtonService,
        private sidebarService: SidebarService,
        private eventService: EventService,
        private userService: UserService,
        private modalService: NgbModal,
        private scrollService: ScrollDirectionService
    ) {}

    ngOnInit(): void {
        this.userServiceSubscription = this.userService.isLoggedIn$.subscribe(
            ({ isLoggedIn }) => {
                this.isUserLoggedIn = isLoggedIn;
            }
        );
        this.scrollService.scrollDirection$.subscribe((dir) => {
            if (dir === 'up' && dir !== this.previousScrollDirection) {
                this.container?.nativeElement?.classList.remove('hide');
            } else if (dir === 'down') {
                this.container?.nativeElement?.classList.add('hide');
            }
            this.previousScrollDirection = dir;
        });
    }

    ngOnDestroy(): void {
        if (this.userServiceSubscription) {
            this.userServiceSubscription.unsubscribe();
        }
        this.scrollService.detach();
    }

    goHome() {
        this.logToSentry('home');
        window.location.href = '/';
    }

    goToCart() {
        this.logToSentry('cart');
        window.location.href = '/cart';
    }

    openSidebar() {
        this.logToSentry('menu');
        this.sidebarService.toggle();
    }

    onProfileClick() {
        this.logToSentry('profile');
        if (!this.isUserLoggedIn) {
            this.eventService.emitEvent(EventType.LOGIN);
        } else {
            this.modalService.open(this.signOutModal, {
                centered: true,
            });
        }
    }

    onSignOut() {
        this.userService.setIsLoggedIn(false, {
            withMessage: true,
            notifyServerOfSignOut: true,
            isManualSignOut: true,
        });
        this.modalService.dismissAll();
    }

    logToSentry(buttonName: string) {
        Sentry.captureMessage(`Appbar button clicked: ${buttonName}`, {
            level: 'info',
            extra: { buttonName },
        });
    }
}
